import { type PropsWithChildren } from "react";

export function PageSubTitle({ children }: PropsWithChildren) {
  return <div className="ml-0 mr-0 text-2xl font-bold">{children}</div>;
}
